import { AnalyticsParams } from "../analyticsClient";
import { compactAnalyticsParams } from "./common";

export type ReadingSessionStartParamsInput = {
  readingSessionUuid: string;
  releaseId: number;
  comicId: number;
  artistId: number;
  lang: string;
  startPage: number;
  totalPages: number;
  isFirstRead: boolean;
  isResuming: boolean;
  viewerMode: string;
  accessMode: string;
  source: string;
  impressionId?: string;
  comicDetailViewId?: number;
};

export type ReadingSessionEndParamsInput = {
  readingSessionUuid: string;
  releaseId: number;
  comicId: number;
  artistId: number;
  lang: string;
  startPage: number;
  endPage: number;
  maxPageReached: number;
  totalPages: number;
  pagesReadInSession: number;
  sessionDurationMs: number;
  viewerMode: string;
  accessMode: string;
};

export function buildReadingSessionStartParams(
  input: ReadingSessionStartParamsInput,
): AnalyticsParams {
  return compactAnalyticsParams({
    reading_session_uuid: input.readingSessionUuid,
    release_id: input.releaseId,
    comic_id: input.comicId,
    artist_id: input.artistId,
    lang: input.lang,
    start_page: input.startPage,
    total_pages: input.totalPages,
    is_first_read: input.isFirstRead,
    is_resuming: input.isResuming,
    viewer_mode: input.viewerMode,
    access_mode: input.accessMode,
    source: input.source,
    impression_id: input.impressionId,
    comic_detail_view_id: input.comicDetailViewId,
  });
}

export function buildReadingSessionEndParams(
  input: ReadingSessionEndParamsInput,
): AnalyticsParams {
  const progressPct =
    input.totalPages > 0
      ? Math.min(
          100,
          Math.max(0, ((input.maxPageReached + 1) / input.totalPages) * 100),
        )
      : 0;

  return compactAnalyticsParams({
    reading_session_uuid: input.readingSessionUuid,
    release_id: input.releaseId,
    comic_id: input.comicId,
    artist_id: input.artistId,
    lang: input.lang,
    start_page: input.startPage,
    end_page: input.endPage,
    max_page_reached: input.maxPageReached,
    total_pages: input.totalPages,
    pages_read_in_session: input.pagesReadInSession,
    progress_pct: Number(progressPct.toFixed(2)),
    session_duration_ms: Math.max(0, input.sessionDurationMs),
    is_complete:
      input.totalPages > 0 && input.maxPageReached >= input.totalPages - 1,
    viewer_mode: input.viewerMode,
    access_mode: input.accessMode,
  });
}
